(() => {
  class ProductNewRating extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (this.id && window.CACHE && window.CACHE[this.id]) {
        this.querySelector("span").innerHTML = window.CACHE[this.id];
      }
      this.mutatinObserver = new MutationObserver(this.onMutation.bind(this));
      this.mutatinObserver.observe(this, { childList: true, subtree: true });
    }

    onMutation() {
      const label = this.querySelector(".stamped-badge-caption[data-rating]");

      if (!label) return;
      this.mutatinObserver.disconnect();

      const rating = label.dataset.rating;
      const reviews = label.dataset.reviews;
      const captionFormat = this.dataset.captionFormat;

      if (captionFormat === "with-reviews") {
        label.innerHTML = `${rating} with 2140+ reviews`;
      } else {
        label.innerHTML = `<span style="margin-right: 4px">${rating}/5</span> <span class="with-underline"> ${reviews} reviews</span>`;
      }

      if (this.id) {
        window.CACHE = window.CACHE || {};
        window.CACHE[this.id] = this.querySelector("span").innerHTML;
      }
    }
  }

  if (!customElements.get("product-new-rating"))
    customElements.define("product-new-rating", ProductNewRating);
})();
